import React from 'react'
import type { InboxConversationDetail } from './inboxTypes'
import { ParticipantPill } from './shared/ParticipantPill'
import { isReviewAuthorParticipant } from './utils'

interface ConversationHeaderProps {
  conversation: InboxConversationDetail
}

export const ConversationPanelHeader: React.FC<ConversationHeaderProps> = ({ conversation }) => {
  return (
    <div className='inbox-conversation-header'>
      {conversation.participants.map((participant) => (
        <ParticipantPill
          key={`${participant.fullName}-${participant.orgName ?? 'no-org'}`}
          participant={participant}
          isReviewAuthor={isReviewAuthorParticipant(participant, conversation.review)}
        />
      ))}
    </div>
  )
}
